import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { getTeams } from "../../../api/teams";
import { useErrorNotification } from "../../../hooks/useErrorNotification";
import PageLoader from "../../PageLoader";
import { Btn, PageHeader } from "../../ui";
import TeamsTable from "./TeamsTable";

const ListTeams = () => {
  const {
    data: teamsData,
    isError,
    isLoading,
  } = useQuery(
    ["teams"],
    () => {
      return getTeams();
    },
    {
      keepPreviousData: true,
      staleTime: 60000,
    },
  );

  useErrorNotification({
    isError,
    title: "Error getting teams list",
    toastId: "team-list-error",
    navigateTo: "/",
  });

  if (isLoading) return <PageLoader />;

  return (
    <>
      <PageHeader
        eyebrow="Admin"
        title="Manage Teams"
        actions={
          <Btn as={Link} to="/admin/teams/create" variant="primary">
            Add Team
          </Btn>
        }
      />
      <TeamsTable data={teamsData?.data?.data} />
    </>
  );
};

export default ListTeams;
